/**
 * ホーミング能力（HUNTER専用機能）
 *
 * このモジュールはホーミングモードの発動、効果持続時間の管理、
 * および発動時の演出用パーティクルの生成を管理します。
 *
 * @module abilities/homing
 */

import { CONFIG } from '../../config/game-config';
import {
    getHomingStock,
    setHomingStock,
    getHomingActive,
    setHomingActive,
    getHomingTimer,
    setHomingTimer,
    setScreenShake,
    getPlayer,
    getParticles
} from '../../store/index';
import { getP5 } from '../../core/p5-instance';
import { updateHomingEffect } from './homing-effects';

/**
 * ホーミングモードの発動処理
 * ストックを消費し、自機弾が敵を追尾するホーミングモードを開始します。
 */
export function useHoming(): void {
    const p = getP5();
    const homingStock = getHomingStock();
    const homingActive = getHomingActive();

    // ストック不足、または既に発動中の場合は何もしない
    if (homingStock <= 0 || homingActive) {
        return;
    }

    setHomingStock(homingStock - 1);
    setHomingActive(true);
    setHomingTimer(CONFIG.ships.hunter.homingDuration);
    setScreenShake(5); // 発動時の軽い画面揺れ

    const player = getPlayer();
    if (!player) {
        return;
    }

    const particles = getParticles();

    // 発動時のパーティクル演出（放射状に広がる）
    for (let i = 0; i < 15; i++) {
        const angle = (p.TWO_PI / 15) * i;
        particles.push({
            x: player.x,
            y: player.y,
            vx: p.cos(angle) * 6,
            vy: p.sin(angle) * 6,
            size: p.random(4, 8),
            color: p.color(255, 180, 0),
            life: p.random(15, 25)
        });
    }
}

/**
 * ホーミングモードの状態更新ロジック
 * 効果持続時間のカウントダウンと、付随するエフェクトの更新を行います。
 *
 * @param dt 経過時間（フレーム倍率）
 */
export function updateHoming(dt: number): void {
    if (!getHomingActive()) {
        return;
    }

    // 視覚演出の状態更新
    updateHomingEffect();

    // 持続タイマーの更新
    let timer = getHomingTimer();
    timer -= dt;
    setHomingTimer(timer);

    // 終了判定
    if (timer <= 0) {
        setHomingActive(false);
    }
}
